<script setup>
// Set signin vs signup based on url param
const isForgotPassword = ref(false);
const isSignUp = ref(useRoute().query.signup == 'true');
const redirectTo = useRoute().query.redirect;
const municipality = useCookie('municipality');

const { transitionColour } = useTailwindConfig();

function toggleSignUpMode() {
  isSignUp.value = !isSignUp.value;
}

// Add watcher so if url param changes the page is reloaded. This is needed because clicking the navbar buttons from this page didn't properly reload the page
watch(() => useRoute().query.signup, () => {
  window.location.reload();
});

//Set to true for now, but can make it to !isForgotPassword later
function toggleForgotPassword() {
  isForgotPassword.value = !isForgotPassword.value;
}
</script>

<template>
  <AuthPage>
    <UCard>
      <template #header>
        <div class="flex gap-2 items-center">
          <button v-if="isForgotPassword && !isSignUp" @click="toggleForgotPassword"
            class="flex items-center p-0.5 rounded-md hover:bg-gray-200" :class="transitionColour">
            <UIcon name="material-symbols:arrow-back-rounded" size="28" />
          </button>
          <h2 class="text-2xl text-gray-700">
            {{ isSignUp ? "Create Account" : isForgotPassword ? "Password Reset" : "Sign In" }}
          </h2>
        </div>
      </template>
      <AuthForm :isSignUp="isSignUp" :isForgotPassword="isForgotPassword" :redirectTo="redirectTo" />
      <div v-if="!isForgotPassword" class="flex flex-col items-center gap-2 mt-4">
        <!-- Builder Account Create Button - only shown when no municipality is set (because on app.siteability.ca without an account) -->
        <p v-if="!municipality" class="text-sm text-gray-600">
          <span v-if="isSignUp">Already have an account? </span>
          <UButton variant="link" color="primary" @click="toggleSignUpMode" class="font-medium">
            <span v-if="!isSignUp">Create a builder account</span>
            <span v-else>Sign in instead</span>
          </UButton>
        </p>

        <!-- Forgot Password Button -->
        <p v-if="!isSignUp" class="text-sm text-gray-500">
          <UButton variant="link" color="gray" @click="toggleForgotPassword" class="font-medium">
            Forgot your password?
          </UButton>
        </p>
      </div>
    </UCard>
  </AuthPage>
</template>